module.exports = "/images/default-project-logo.jpg?7fb672184a637a1227372feab1b0c3cf";